import React from "react";
import Navbar from "../../components/Navbar";
import "./styles.css";
import { Card, Col, Row } from "antd";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { Pie } from "react-chartjs-2";

export const data = {
  labels: ["Caja a", "Caja b", "Caja c", "Caja d", "Caja e", "Caja f"],
  datasets: [
    {
      label: "# of Votes",
      data: [12, 19, 3, 5, 2, 3],
      backgroundColor: [
        "rgba(255, 99, 132, 0.2)",
        "rgba(54, 162, 235, 0.2)",
        "rgba(255, 206, 86, 0.2)",
        "rgba(75, 192, 192, 0.2)",
        "rgba(153, 102, 255, 0.2)",
        "rgba(255, 159, 64, 0.2)",
      ],
      borderColor: [
        "rgba(255, 99, 132, 1)",
        "rgba(54, 162, 235, 1)",
        "rgba(255, 206, 86, 1)",
        "rgba(75, 192, 192, 1)",
        "rgba(153, 102, 255, 1)",
        "rgba(255, 159, 64, 1)",
      ],
      borderWidth: 1,
    },
  ],
};

const BilleteraOverview = () => (
  <div className="container">
    <h1>Movimientos por Billeteras</h1>
    <Row gutter={16}>
      <Col span={5}>
        <Card title="Billeteras" bordered={true}>
          List
        </Card>
      </Col>
      <Col span={5}>
        <Card title="De:" bordered={true}>
          DATA
        </Card>
      </Col>
      <Col span={5}>
        <Card title="A:" bordered={true}>
          DATA
        </Card>
      </Col>
    </Row>
    <div className="graph">
      <Row>
        <Col span={10}>
          <Card title="Cajas con Plata" bordered={true}>
            <div className="pie2">
              <Pie data={data} />
            </div>
          </Card>
        </Col>
      </Row>
    </div>
  </div>
);
export default BilleteraOverview;
